export const formatDate = (date: Date, view: 'month' | 'week' | 'day'): string => {
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    year: 'numeric'
  };

  if (view === 'week') {
    const weekStart = new Date(date);
    weekStart.setDate(date.getDate() - date.getDay());
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);
    
    return `${weekStart.getDate()} - ${weekEnd.getDate()} de ${weekStart.toLocaleDateString('pt-BR', { month: 'long' })}`;
  }

  if (view === 'day') {
    options.day = 'numeric';
  }

  return date.toLocaleDateString('pt-BR', options);
};

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const getWeekDays = (locale: string = 'pt-BR'): string[] => {
  const baseDate = new Date(2024, 0, 1); // Monday
  const weekDays = [];
  
  for (let i = 0; i < 7; i++) {
    weekDays.push(
      baseDate.toLocaleDateString(locale, { weekday: 'short' })
    );
    baseDate.setDate(baseDate.getDate() + 1);
  }
  
  return weekDays;
};

// Format time to Brazilian format (24h)
export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

// Parse time string in Brazilian format
export const parseTime = (timeString: string): Date => {
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};